import { jsx } from 'react/jsx-runtime';

const SvgNewWindow = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 10.504a.5.5 0 0 1 1 0v3.183c0 .724-.589 1.313-1.313 1.313H4.312A1.314 1.314 0 0 1 3 13.686V4.312C3 3.589 3.588 3 4.312 3h3.187a.5.5 0 0 1 0 1H4.312A.316.316 0 0 0 4 4.312v9.375c0 .169.143.313.312.313h9.376a.318.318 0 0 0 .312-.313v-3.183Zm-3.5-7.502h3.188c.723 0 1.312.589 1.312 1.312v3.187a.5.5 0 0 1-1 0V4.79L9.887 9.816a.495.495 0 0 1-.703.071.5.5 0 0 1-.07-.704l4.24-5.181H10.5a.5.5 0 0 1 0-1Z",
        fill: "#445058"
      }
    )
  }
);

export { SvgNewWindow as default };
//# sourceMappingURL=NewWindow.js.map
